import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";
import type { InvitationCardProps } from "../../../types/ChatCard";

const formatValue = (value: unknown): string => {
  if (typeof value === "boolean") {
    return value ? t("yes") : t("no");
  }
  if (Array.isArray(value)) {
    return value.join(", ");
  }
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  return JSON.stringify(value);
};

const shouldDisplayField = (_key: string, value: unknown): boolean => {
  if (value === null || value === undefined || value === "") {
    return false;
  }

  return !(typeof value === "boolean" && !value);
};

export const ProfileFieldCard = ({
  title,
  url,
  params,
}: InvitationCardProps) => {
  const displayParams = Object.entries(params || {}).filter(([key, value]) =>
    shouldDisplayField(key, value),
  );

  return (
    <div
      className="bg-primary border-primary flex w-[368px] min-w-0 flex-1 flex-col items-start gap-3 self-stretch rounded-2xl border p-4"
      style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}
    >
      <Typography.BodySm weight="font-bold" color="text-dark">
        {title}
      </Typography.BodySm>

      {displayParams.length > 0 && (
        <ul className="flex flex-col leading-5">
          {displayParams.map(([key, value]) => (
            <li key={key} className="!pb-0">
              <Typography.BodySm color="text-dark">
                <strong>{key}:</strong> {formatValue(value)}
              </Typography.BodySm>
            </li>
          ))}
        </ul>
      )}

      <Button
        onClick={() => {
          window.location.href = url;
        }}
        variant="circle"
        className="w-full"
      >
        <Typography.BodySm weight="font-medium" color="text-primary">
          {t("help_widget.copilot.chat_card.preview_button")}
        </Typography.BodySm>
      </Button>
    </div>
  );
};
